import { ChangeDetectionStrategy, Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { RecipientsSearchService } from './recipients-search.service';

@Component({
  selector: 'dl-recipients-search',
  templateUrl: './recipients-search.component.html',
  styleUrls: ['./recipients-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecipientsSearchComponent implements OnInit {
  public searchbox = new FormControl();
  public constructor(private recipientsSearchService: RecipientsSearchService) {}
  public ngOnInit(): void {}
  public applyFilter(filterValue: string): void {
    this.recipientsSearchService.getSearchedData(filterValue.trim().toLocaleLowerCase());
  }
}
